import React from "react";

export default function App() {
  const links = [
    { title: "PRICE CHECK GT - OMP HB", url: "https://drive.google.com/drive/folders/1gmEKzouZOBODIH7qMITl6BLeQT7mAFD6?usp=sharing"},
    { title: "REPORT GIMMICK - HB", url: "https://drive.google.com/drive/folders/1k96nH8rBFnJSopt9DVqCORlEBL-yRCSk?usp=sharing" },
    
  ];

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-6" style={{backgroundColor:'#2b236f'}}>
      <div className="max-w-md w-full  backdrop-blur-xl shadow-2xl rounded-3xl p-8 text-center border border-white/30" style={{backgroundColor:'#165db1'}}>

        {/* Foto Profil */}
        <div className="flex justify-center">
          <img
            src="/sukanda.png"
            alt="profile"
            className="w-28 h-28  object-cover shadow-xl"
          />
        </div>

        <h2 className="text-2xl font-bold text-white mt-4 mb-6 drop-shadow-lg">
          Report Sukanda - GT
        </h2>

        {/* Link Buttons */}
        <div className="space-y-4">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white/90 text-black py-3 rounded-xl text-sm font-semibold hover:bg-white hover:text-gray-900 transition-all p-2 shadow-md backdrop-blur-md border border-white/30"
            >
              {link.title}
            </a>
          ))}
        </div>

      </div>
    </div>
  );
}
